
import axios from 'axios';
import React, {useState} from 'react'
import config from '../config'
import loadingIcon from '../images/loading.svg'
import { useTranslation } from 'react-i18next'
import { PRODUCT_CATEGORIES } from '../constants/productCategories'
export default function UploadProductForm({setShowUploadProductForm}) {
    const { t } = useTranslation();
    const [name, setName] = useState(null);
    const [category, setCategory] = useState(PRODUCT_CATEGORIES[0].value);
    const [price, setPrice] = useState(null);
    const [priceEur, setPriceEur] = useState(null);
    const [lastPrice, setLastPrice] = useState(null);
    const [lastPriceEur, setLastPriceEur] = useState(null);
    const [description, setDescription] = useState(null);
    const [composition, setComposition] = useState(null);
    const [compositionEn, setCompositionEn] = useState(null);
    const [image, setImage] = useState(null);
    const [movie, setMovie] = useState(null);
    const [compositionImage, setCompositionImage] = useState(null);
    const [demensions, setDemensions] = useState(null);
    const [installationPrice, setInstallationPrice] = useState(null);
    const [installationPriceEur, setInstallationPriceEur] = useState(null);
    const [soldOut, setSoldOut] = useState(false);
     const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(false);


    const [error, setError] = useState(null);

    async function sendForm(e) {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const formData = new FormData();
        formData.append("installationPrice", installationPrice);
        formData.append("installationPriceEur", installationPriceEur || '');
        formData.append("soldOut", soldOut);
        formData.append("category", category);
        formData.append("name", name);
        formData.append("price", price);
        formData.append("priceEur", priceEur || '');
        formData.append("lastPrice", lastPrice);
        formData.append("lastPriceEur", lastPriceEur || '');
        formData.append("description", description);
        formData.append("composition", composition);
        formData.append("compositionEn", compositionEn || '');
        formData.append("demensions", demensions);
        formData.append("image", image);
        formData.append("movie", movie);
        formData.append("compositionImage", compositionImage);

        galleryImages.forEach((file, index) => {
            formData.append(`gallery`, file);
        });

        try {
            await axios.post(`${config.API_URL}/api/product/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("access_tocken")}` }
            });
            window.location.reload();
        } catch (error) {
            setError(error.response.data);
        }finally {
        setLoading(false);
    }
    }

if (loading == true) {
        return <div className='loading'><img src={loadingIcon} alt='none gif'></img></div>
    }
    return (
        <div className='updateProduct'>
            <form onSubmit={sendForm}>
                <div className='updateProduct-main'>
                    <div className='updateProduct-fields'>
                        <label>{t('uploadForm.name')}</label>
                        <input type="text" name="name" onChange={(e) => setName(e.target.value)} />
                        <label>{t('uploadForm.price')}</label>
                        <input type="number" name="price" onChange={(e) => setPrice(e.target.value)} />
                        <label>{t('uploadForm.priceEur')}</label>
                        <input type="number" name="priceEur" onChange={(e) => setPriceEur(e.target.value)} />
                        <label>{t('uploadForm.lastPrice')}</label>
                        <input type="number" name="lastPrice" onChange={(e) => setLastPrice(e.target.value)} />
                        <label>{t('uploadForm.lastPriceEur')}</label>
                        <input type="number" name="lastPriceEur" onChange={(e) => setLastPriceEur(e.target.value)} />
                        <label>{t('uploadForm.installationPrice')}</label>
                        <input type="number" name="installationPrice" onChange={(e) => setInstallationPrice(e.target.value)} />
                        <label>{t('uploadForm.installationPriceEur')}</label>
                        <input type="number" name="installationPriceEur" onChange={(e) => setInstallationPriceEur(e.target.value)} />
                        <label>Sold out</label>
                        <input type="checkbox" name="soldOut" checked={soldOut} onChange={(e) => setSoldOut(e.target.checked)} />
                        <label>{t('uploadForm.category')}</label>
                        <select name="category" value={category} onChange={(e) => setCategory(e.target.value)}>
                            {PRODUCT_CATEGORIES.map(cat => (
                                <option key={cat.value} value={cat.value}>{cat.label}</option>
                            ))}
                        </select>
                        <label>{t('uploadForm.description')}</label>
                        <textarea name="description" onChange={(e) => setDescription(e.target.value)} />
                        <label>{t('uploadForm.demensions')}</label>
                        <textarea name="demensions" onChange={(e) => setDemensions(e.target.value)} />
                        <label>{t('uploadForm.composition')}</label>
                        <textarea name="composition" onChange={(e) => setComposition(e.target.value)} />
                        <label>{t('uploadForm.compositionEn')}</label>
                        <textarea name="compositionEn" onChange={(e) => setCompositionEn(e.target.value)} />
                        <label>{t('uploadForm.compositionImage')}</label>
                        <input type='file' onChange={(e) => setCompositionImage(e.target.files[0])} />
                        <label>{t('uploadForm.image')}</label>
                        <input type='file' onChange={(e) => setImage(e.target.files[0])} />
                        <label>{t('uploadForm.movie')}</label>
                        <input type='file' onChange={(e) => setMovie(e.target.files[0])} />
                    </div>
                    {image && <img src={URL.createObjectURL(image)} alt="Product" />}
                </div>

                <div className='updateProduct-gallery'>
                    <label>{t('uploadForm.gallery')}</label>
                    <input type='file' multiple onChange={(e) => setGalleryImages(Array.from(e.target.files))} />
                </div>

                <button type='submit'>{t('uploadForm.submit')}</button>
            </form>
        </div>
    )
}
